import { INITIALIZE_GENERATION_RATIO } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_GENERATION_RATIO](values);
